import { useV2ListPrivilegesQuery } from "@generated";
import { Privilege } from "../types";

const useListPrivileges = () => {
  const { data, isLoading, isFetching, refetch } = useV2ListPrivilegesQuery();

  let privileges: Privilege[] = [];
  let customError: string | null = null;

  if (data?.data) {
    try {
      privileges = data?.data.map((privilege) => {
        return {
          id: privilege.id || "",
          description: privilege?.attributes?.description || "",
          levels: privilege?.attributes?.levels || [],
        };
      });
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }

  return {
    privileges,
    isLoading,
    refetch,
  };
};

export default useListPrivileges;
